import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import * as faceapi from 'face-api.js';

@Injectable({
	providedIn: 'root'
})
export class FaceDetectionService {

	private video: HTMLVideoElement | null = null;
	private isRunning = false;
	private loopHandle: any;
	private modelsLoaded = false;
	private readonly FPS = 6;
	private detectionSubject = new Subject<any[]>();
	detections$ = this.detectionSubject.asObservable();

	constructor(private ngZone: NgZone) {}

	async loadModels(): Promise<void> {
		if (this.modelsLoaded) return;
		const path = '/assets/models';
		try {
			await Promise.all([
				faceapi.nets.tinyFaceDetector.loadFromUri(path),
				faceapi.nets.faceLandmark68Net.loadFromUri(path)
			]);
			this.modelsLoaded = true;
		} catch (err) {
			console.error('[FaceDetection] Model load failed ', err);
		}
	}


	async start(video: HTMLVideoElement): Promise<void> {
		await this.loadModels();
		this.video = video;
		this.isRunning = true;
		this.ngZone.runOutsideAngular(() => {
			this.loop();
		});
	}


	stop(): void {
		this.isRunning = false;
		clearTimeout(this.loopHandle);
		this.video = null;
	}


	private async loop(): Promise<void> {
		if (!this.isRunning || !this.video) return;

		if (!this.video.paused && !this.video.ended && this.video.readyState >= 2) {
			try {
				const options = new faceapi.TinyFaceDetectorOptions({
					inputSize: 512,
					scoreThreshold: 0.2
				});

				const detections = await faceapi
					.detectAllFaces(this.video, options)
					.withFaceLandmarks();

				this.ngZone.run(() => {
					this.detectionSubject.next(detections);
				});

			} catch (err) {
				console.error('[FaceDetection] Detection error:', err);
			}
		}

		if (this.isRunning) {
			this.loopHandle = setTimeout(() => this.loop(), 1000 / this.FPS);
		}
	}
	
}